import useLanguage from "../utils/useLanguage";
import { FailedIcon } from "../assets/registtyIcons/icons";

export default function ErrorBox({ children }) {
  const { currentDirection } = useLanguage();

  return (
    <div className="errorBox" style={{ direction: currentDirection }}>
      <FailedIcon width={20} height={20} />
      <div className="errorBoxText">{children}</div>
    </div>
  );
}
